import { Button } from '@workramp/ui';
import styled from 'styled-components';

type StyledFilterButtonProps = {
  $paddingRight: number;
};

export const StyledFilterButton = styled(Button)<StyledFilterButtonProps>`
  padding-right: ${({ $paddingRight }) => $paddingRight}px;
`;
